import router from './index.js';
import moduleName from './index.js';

router.beforeEach((to, from, next) => {
  // 在这里可以添加一些全局的路由守卫逻辑
    const title = to.meta.title;
    document.title = title;
    // console.log(title,'title');
    next();
});